'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
* Wrapper class for images on HelloSign.
* Deprecated - <img /> elements work just fine now since image sources are resolved via webpack. (CC)
*/

var Image = _react2['default'].createClass({
    displayName: 'Image',


    propTypes: {
        'path': _react2['default'].PropTypes.string,
        'url': _react2['default'].PropTypes.string,
        'className': _react2['default'].PropTypes.string,
        'style': _react2['default'].PropTypes.object
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'path': null,
            'url': null,
            'className': '',
            'style': {}
        };
    },

    getInitialState: function getInitialState() {
        return {};
    },

    //  ----  BEHAVIOR  -----------------------------------

    //  ----  RENDERING  ----------------------------------

    render: function render() {

        var src = this.props.url;
        var klass;
        var style;

        klass = this.props.className;
        style = this.props.style;

        return _react2['default'].createElement('img', _extends({}, this.props, { src: src }));
    }
});

module.exports = Image;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/image.jsx
 ** module id = 692
 ** module chunks = 0
 **/